import React, { useEffect, useState } from "react";
import { INSIGHTS_LATEST_URL, INSIGHTS_PATH, validInsights } from "../insights/insightsLinks";
import './InsightsStrip.css';

// "From the data" on the landing page, under the Big Picture strip: the 3 newest insights
// articles as cards, read from latest.json (written by scripts/insights/build_insights.py), so a
// new article shows here with no change to the app. Fetched after the page has loaded; nothing
// is shown while loading, or if the file is missing, empty or bad.

const InsightsStrip = () => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        let live = true;
        const ctrl = new AbortController();
        const load = () => fetch(INSIGHTS_LATEST_URL, {signal:ctrl.signal, credentials:'omit'})
            .then((r) => (r.ok ? r.json() : []))
            .then((list) => { if (live) setItems(validInsights(list)); })
            .catch(() => {});
        // After the page's own work, so it never competes with the hero
        const idle = window.requestIdleCallback ? window.requestIdleCallback(load, {timeout:2500}) : window.setTimeout(load, 600);
        return () => {
            live = false;
            ctrl.abort();
            if (window.cancelIdleCallback && window.requestIdleCallback) window.cancelIdleCallback(idle); else window.clearTimeout(idle);
        };
    }, []);

    if (!items.length) return null;
    return (
        <section className="wrap block ins" aria-labelledby="ins-head">
            <div className="ins-head">
                <a className="sign-label" id="ins-head" href={INSIGHTS_PATH}>FROM THE DATA</a>
                <span className="ins-line">What our maps show about where to live.</span>
                <a className="ins-all" href={INSIGHTS_PATH}>All insights <span aria-hidden="true">→</span></a>
            </div>
            <ul className="ins-cards">
                {items.map((a) => (
                    <li key={a.url}>
                        <a className="ins-card" href={a.url}>
                            {a.image && <img src={a.image} alt="" width="640" height="400" loading="lazy" decoding="async"/>}
                            <span className="ins-body">
                                <span className="ins-title">{a.title}</span>
                                {a.description && <span className="ins-desc">{a.description}</span>}
                            </span>
                        </a>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default InsightsStrip;
